<template>
  <nav v-if="$route.meta.menu">
    <!--{{$route.meta.menu}}-->
    <p class="primary-nav" v-if="!$store.state.system">
        {{$route.meta.app ? $route.meta.app.name: $route.meta.menu.name}}
    </p>
      <el-select v-if="$store.state.system"
        v-model="selectedAppId"
        placeholder="请选择"
        style="margin: 20px 10px"
        @change="selected"
        filterable
        size="small">
        <el-option
          v-for="app in $store.state.apps"
          :key="app.id"
          :label="app.name"
          :value="app.id">
          <span style="float: left; font-weight: bold">
            <img v-if="app.icon" :src="app.icon" style="width: 16px; height: 16px"></img>
            <img v-if="!app.icon && app.os_type == 1"
              src="@/assets/imgs/android.png" style="width: 16px; height: 16px"></img>
            <img v-if="!app.icon && app.os_type == 2"
              src="@/assets/imgs/ios.png" style="width: 16px; height: 16px"></img>
            {{ app.name }}
          </span>
          <span style="float: right; color: #8492a6; font-size: 11px">{{ app.package_name }}</span>
        </el-option>
      </el-select>

    <ul>
      <li v-for="link in $route.meta.menu.children">
        <router-link class="sub-nav text-overflow" :to="link.url.replace(':app_id',$route.params.app_id).replace(':system',$route.params.system)">{{link.name}}</router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
  export default {
    name:"LeftNavMenu",
    props:['title','links','cururl'],
    data() {
      return {
        selectedAppId: undefined,
      }
    },
    mounted() {
      this.selectedAppId = this.$store.state.appId;
    },
    methods: {
      selected(appId) {
        this.$store.commit('setAppId', appId);
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "@/assets/css/varible.less";
  .primary-nav{
      display: block;
      padding-left: 18px;
      height: 68px;
      font-size: 18px;
      line-height: 68px;
      font-weight: bold;
  }
  .sub-nav{
      display: block;
      padding-left: 30px;
      font-size: 16px;
      line-height: 56px;
  }
  .router-link-active,.active{
    color:#1eb8da;
    background: #1d2731;
    position:relative;
    &::after{
      content:'';
      position:absolute;
      right: 0;
      top:50%;
      margin-top: -6px;
      border:8px solid transparent;
      border-right: 12px solid @gray;

    }
  }
  /deep/.el-input__inner {
    font-weight: bold;
    opacity: 0.4;

  }
</style>

